import LeaderOrder from "./LeaderOrder";

const LeaderOrderContainer = (props: any) => <LeaderOrder isBulkOrder={props?.isBulkOrder}/>

export default LeaderOrderContainer
